import React, { useCallback, useMemo } from "react";
import * as Scrivito from "scrivito";
import { useMutation } from "urql";
import { GenerateReportArchiveMut } from "api/mutations";
import { useSharedWorker } from "providers/SharedWorkerProvider/SharedWorkerContext";
import { useAppBaseContext } from "providers";
import { useRequestsToLocalStorageManager } from "hooks/useRequestsToLocalStorageManager";

import { useTranslate } from "hooks";
import { projectFolderReportConfig } from "config/reports";
import { Icon } from "../../Icon/Icon";
import { Button } from "../../Button";

const reportKinds = {
  BOM_COMPACT: "BOM_COMPACT",
};

export const ProductListDownloadButton = Scrivito.connect(
  ({ projectId, downloadAllowed = false, nodeId }) => {
    const translate = useTranslate();
    const { lang } = useAppBaseContext();

    const { removeRequest } = useRequestsToLocalStorageManager();

    const [{ fetching: reportFetching }, requestReportArchive] = useMutation(
      GenerateReportArchiveMut,
    );

    const { startPolling, getMessageByNodeId } = useSharedWorker();

    const requestInProgress = useMemo(
      () => getMessageByNodeId(nodeId || projectId) || null,
      [getMessageByNodeId, nodeId, projectId],
    );

    const handleDownload = useCallback(() => {
      const reportType = projectFolderReportConfig[1].children.find(
        (report) => report.id === reportKinds.BOM_COMPACT,
      );

      if (downloadAllowed) {
        requestReportArchive({
          input: {
            wizardNodeId: nodeId,
            projectId,
            languageCode: lang,
            reports: [
              {
                type: reportType.id,
                fileName: translate(reportType.translationKey),
                directoryName: translate("BOM_REPORTS"),
              },
            ],
            nodeId,
          },
        }).then((result) => {
          if (result?.data?.generateReportArchive?.requestId) {
            if (requestInProgress?.requestId) {
              removeRequest(requestInProgress.requestId);
            }
            startPolling(
              nodeId || projectId,
              result?.data?.generateReportArchive.requestId,
              {
                projectId,
                nodeId,
                initialOperation: result.operation,
              },
            );
          }
        });
      }
    }, [
      downloadAllowed,
      requestReportArchive,
      nodeId,
      projectId,
      lang,
      requestInProgress?.requestId,
      startPolling,
      removeRequest,
      translate,
    ]);

    return (
      <Button
        data-testid="ProductListDownload_download-list-btn"
        color="light"
        className="border border-gray-300 text-gray-700 px-2 py-1"
        isLoading={reportFetching || requestInProgress}
        onClick={handleDownload}
        disabled={!downloadAllowed}
      >
        <Icon
          prefix="trox"
          iconName="arrow-down-bracket-regular"
          className="me-1"
        />
        {translate("DOWNLOAD_LIST")}
      </Button>
    );
  },
);
